import React from "react";
import { useNavigate } from "react-router-dom";

export const SetupCompleteProfile = () => {
  const navigate = useNavigate();

  // All sections completed (per screenshot 1)
  const sections = [
    { title: "Personal Details", desc: "Business Name, Business Email, Business Type, Business Owner & Phone Number" },
    { title: "Verification", desc: "Business Licence, Store Address Proof & Tax ID Proof" },
    { title: "Product & payment", desc: "Product Categories, Shipping Capabilities & Payment Details" },
    { title: "Security & Terms", desc: "Account Security, Two Factor Authentication & Terms & Policies" },
    { title: "Add Products", desc: "Account Security, Two Factor Authentication & Terms & Policies" },
    { title: "Set Up Delivery Details", desc: "Account Security, Two Factor Authentication & Terms & Policies" },
  ];

  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="app-container [font-family:'Nunito',Helvetica] text-[#5d4037] pb-6">

        {/* Top bar */}
        <div className="w-full flex items-center mt-4">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="ml-4 w-9 h-9 rounded-full bg-[#ccb357] grid place-items-center"
            aria-label="Back"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="#5d4037" strokeWidth="2" viewBox="0 0 24 24">
              <path d="M15 18l-6-6 6-6" />
            </svg>
          </button>
          <h1 className="flex-1 text-center font-bold text-[18px]">Complete Profile</h1>
          <div className="w-9" />
        </div>

        {/* Avatar + edit */}
        <div className="mt-5 w-full flex justify-center">
          <div className="relative">
            <img
              alt="avatar"
              className="w-[96px] h-[96px] rounded-full object-cover border-[3px] border-[#cdb966]"
              src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=400&auto=format&fit=crop"
            />
            <button
              type="button"
              className="absolute -bottom-1 -right-1 w-7 h-7 rounded-full bg-[#5d4037] grid place-items-center"
              aria-label="Edit photo"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="#fff8e1">
                <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z"/><path d="M20.71 7.04a1.003 1.003 0 000-1.42L18.37 3.29a1.003 1.003 0 00-1.42 0l-1.83 1.83 3.75 3.75 1.84-1.83z"/>
              </svg>
            </button>
          </div>
        </div>

        {/* Progress */}
        <p className="mt-3 text-center font-extrabold">6/6 Completed</p>
        <p className="mt-1 text-center text-[14px] w-[320px] mx-auto">
          You must complete your profile to start selling and manage products
        </p>

        {/* List */}
        <div className="mt-4 space-y-4 px-4">
          {sections.map((s, idx) => (
            <div key={idx} className="relative">
              {/* Left check badge */}
              <div className="absolute -left-1 top-1">
                <div className="w-6 h-6 rounded-full bg-[#5d4037] grid place-items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="#fff8e1">
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                </div>
              </div>
              <div className="ml-6 rounded-[12px] bg-[#eadfb7] px-4 py-3">
                <p className="font-bold">{s.title}</p>
                <p className="text-[13px]">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* iOS home indicator bar (per screenshot) */}
        <div className="mt-6 w-[260px] h-[8px] rounded-full bg-[#5d4037] mx-auto" />
      </div>
    </div>
  );
};
